import { render, staticRenderFns } from "./AdminPromotions.vue?vue&type=template&id=2935d30f&scoped=true&"
import script from "./AdminPromotions.vue?vue&type=script&lang=js&"
export * from "./AdminPromotions.vue?vue&type=script&lang=js&"
import style0 from "./AdminPromotions.vue?vue&type=style&index=0&id=2935d30f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2935d30f",
  null
  
)

export default component.exports